module.exports = __webpack_public_path__ + "img/gc_black.91c758ed.png";